import type { SliderTrackBand } from '../utils';
import { sliderTrackGridTemplateColumns } from '../utils';

type Props = {
  bands: SliderTrackBand[];
};

export const SliderLabels = ({ bands }: Props) => {
  return (
    <div
      className="grid"
      style={{ gridTemplateColumns: sliderTrackGridTemplateColumns(bands) }}
    >
      {bands.map(({ label, threshold, align }) => (
        <div
          key={threshold}
          className="grid text-tiny text-subtle"
          style={{
            justifyItems: align,
          }}
        >
          {label}
        </div>
      ))}
    </div>
  );
};
